import styled from "styled-components";

export const ContainerButtton = styled.button`
  background-color: #FF0000;
  color: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  display: flex;
  align-Items: center;
  gap: 6px;
  font-Weight: bold;
  font-size: 11px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  white-space: nowrap;
`;
